/**
 * Login. Email + contraseña obligatorios.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { Loader2, Sparkles, KeyRound, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useAuth } from '@/features/auth/AuthProvider';

function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate({ to: '/' });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <div className="bg-card w-full max-w-sm rounded-2xl border p-8 shadow-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="bg-brand text-brand-foreground mb-3 flex h-12 w-12 items-center justify-center rounded-xl">
            <Sparkles className="h-6 w-6" />
          </div>
          <h1 className="text-xl font-semibold tracking-tight">Base de Conocimiento</h1>
          <p className="text-muted-foreground mt-1 text-sm">Repuestos España · Acceso interno</p>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div>
            <label htmlFor="email" className="text-sm font-medium">
              Correo corporativo
            </label>
            <div className="relative mt-1">
              <Mail className="text-muted-foreground absolute left-2.5 top-2 h-4 w-4" />
              <Input
                id="email"
                type="email"
                autoFocus
                required
                placeholder="nombre@repuestosespana.cl"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-8"
              />
            </div>
          </div>

          <div>
            <label htmlFor="password" className="text-sm font-medium">
              Contraseña
            </label>
            <div className="relative mt-1">
              <KeyRound className="text-muted-foreground absolute left-2.5 top-2 h-4 w-4" />
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-8"
              />
            </div>
          </div>

          {error && (
            <p className="text-destructive bg-destructive/10 rounded-md px-3 py-2 text-sm">
              {error}
            </p>
          )}
          <Button type="submit" className="w-full" disabled={loading}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Ingresar
          </Button>
        </form>

        <p className="text-muted-foreground mt-6 text-center text-xs">
          ¿No tienes acceso? Pídele a un administrador que cree tu cuenta y te asigne contraseña.
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/login')({ component: LoginPage });
